import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { AfectacionesCompraConstant, AfectacionesVentaConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

const TipoAfectacionFormGroup = ({
  afectacionCompras,
  iError,
  iTouched,
  fIsSubmitting,
  nextNodeId,
  tieneCentroCosto
}) => {
  const onKeyDown = React.useCallback(
    e => {
      if (tieneCentroCosto) {
        KeyEventUtil.leaveOnEnterOrTab('select-modalavanz-centrocosto', e)
      } else {
        KeyEventUtil.leaveOnEnterOrTab(nextNodeId, e)
      }
    },
    [nextNodeId, tieneCentroCosto]
  )

  return (
    <Form.Group>
      <Form.Label text='AFECTACION' htmlFor='select-modalavanz-tipoAfectacion' md={12} />
      <Col md={12}>
        <Field name='tipoAfectacion'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-modalavanz-tipoAfectacion'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            >
              <option value=''>Seleccionar</option>
              {!afectacionCompras ? (
                <>
                  {AfectacionesVentaConstant.__array.map((x, k) => (
                    <option key={k} value={x.id}>
                      {x.nombre}
                    </option>
                  ))}
                </>
              ) : (
                <>
                  {AfectacionesCompraConstant.__array.map((x, k) => (
                    <option key={k} value={x.id}>
                      {x.nombre}
                    </option>
                  ))}
                </>
              )}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoAfectacionFormGroup)
